var _circle, _circle2, _rect, _rect2, _path, _rect3, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAbcSeparateTrustPlan = function SvgAbcSeparateTrustPlan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 424,
    height: 94,
    fill: "none",
    viewBox: "0 0 424 94"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 196,
    cy: 24.5,
    r: 8,
    fill: "#4B5563"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 228,
    cy: 24.5,
    r: 8,
    fill: "#4B5563"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    x: 172,
    y: 57.5,
    fill: "#4B5563",
    rx: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    x: 202,
    y: 57.5,
    fill: "#4B5563",
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#D1D5DB",
    d: "M212 41.5v16"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    x: 232,
    y: 57.5,
    fill: "#4B5563",
    rx: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D1D5DB",
    d: "M242 57.5v-3.237a4 4 0 0 0-4-4h-22a4 4 0 0 1-4-4V41.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D1D5DB",
    d: "M228 32.5v2.333a4 4 0 0 1-4 4h-8a4 4 0 0 0-4 4V46.5M196 32.5v2.333a4 4 0 0 0 4 4h8a4 4 0 0 1 4 4V46.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D1D5DB",
    d: "M182 57.5v-3.237a4 4 0 0 1 4-4h22a4 4 0 0 0 4-4V41.5"
  })));
};
export default SvgAbcSeparateTrustPlan;